import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Globals } from '../../_models/globals';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { ApiIntegration } from '../../_services/api.integration';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../_services/alert.service';
import { environment } from '../../../environments/environment';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { OrderMenu } from '../../_models/orderMenu';

@Component({
  selector: 'app-customercare-orders',
  templateUrl: './customercare-orders.component.html',
  styleUrls: ['./customercare-orders.component.scss'],
})
export class CustomercareOrdersComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  ordersMainMenu: OrderMenu[] = [
    { displayName: "In Transit", tabClicked: "InTransit", orderStatus: "IN_TRANSIT", additional: "N" },
    { displayName: "Awaiting Carrier", tabClicked: "awaitingCarrier", orderStatus: "AWAITING_CARRIER", additional: "N" }
  ];
  tabClicked: any = 'InTransit';
  orderStatus: any = 'IN_TRANSIT';
  ordersData: any;
  needActionPopup: string = 'N';
  ReattemptRequestPopup: string = 'N';
  escalatePopup: string = 'N';
  actionInstructions: string;
  needActionReason: string;
  viewCustomer: any = {};
  addresses: any;
  checkedList: any;
  orders: any;
  totalRecords: number;
  previousStatus = '';
  masterSelected: boolean = false;
  actionReasons: any = [];

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private g: Globals, public user: User, private api: ApiIntegration) {
    this.g.page = "Orders View";
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      for (let ol of this.ordersMainMenu) {
        if (ol.tabClicked === this.g.pageTab) {
          this.populateTabData(this.g.pageTab, ol.orderStatus);
          this.switchPosition(ol);
        }
      }
    } else {
      this.tabClicked = "InTransit";
      this.populateTabData('InTransit', "IN_TRANSIT");
    }
  }

  checkUncheckAll() {
    for (var i = 0; i < this.orders.length; i++) {
      this.orders[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  populate(orderChange) {
    this.g.loaderDisplay = "display";
    this.api.getStockTransferList(orderChange, "ORDER", "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.orders = data.ordersData;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false
    }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.orders.length; i++) {
      if (this.orders[i].isSelected) {
        this.checkedList.push(this.orders[i]['orderHeaderId']);
      }
    }
  }

  populateTabData(triggered, orderStatus) {
    this.tabClicked = triggered;
    this.orderStatus = orderStatus;
    if (!this.previousStatus) {
      this.getOrdersByStatus(orderStatus);
    } else {
      this.rerender();
    }
  }

  getOrdersByStatus(status) {
    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      language: {
        searchPlaceholder: 'Search by Order # / Channel Order # / Phone Number / Email'
      },
      serverSide: true,
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.orderStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.orderStatus;
        }
        let query: any = {
          orderStatus: this.orderStatus,
          orderType: 'ORDER',
          organizationId: 1,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === "ROLE_USER") {
          query.accountOwnerId = this.user.accountOwnerId;
        }
        this.g.loaderDisplay = "display";
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        this.http.get(environment.apiUrl + "api/getOrderConsignmentsByStatus", { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.orders = resp.ordersData;
            this.g.loaderDisplay = "";
            this.totalRecords = resp.noOfOrders;
            this.orders.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfOrders,
              recordsFiltered: resp.noOfOrders
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };

  }
  switchPosition(om) {
    let index = this.ordersMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.ordersMainMenu[4].displayName) {
      this.ordersMainMenu[4].additional = 'Y';
    }
    var tmp = 5;
    for (let o of this.ordersMainMenu) {
      if (tmp < this.ordersMainMenu.length) {
        if (om.displayName !== this.ordersMainMenu[tmp].displayName) {
          this.ordersMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

  tabChange() {
    this.checkedList = [];
    this.g.loaderDisplay = "display";
  }


  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  ReattemptRequestPopupOpen() {
    this.ReattemptRequestPopup = 'Y';
    this.viewCustomer = {
      "code": "200",
      "message": "Success",
      "role": null,
      "organizationId": 1,
      "id": 1,
      "accountType": "ACCOUNT_OWNER",
      "companyName": "Test123",
      "ownerName": "Sandeep",
      "mobile": 8904291446,
      "email": "sandeep@snithik.com",
      "status": "ACTIVE",
      "panCard": "NO",
      "panCardNumber": null,
      "aadharCard": "NO",
      "aadhartCardNumber": null,
      "mouDocument": "https://shift-images.s3.ap-south-1.amazonaws.com/Img-26-09-2021-8-49-35Before%20change.txt",
      "adddressList": [{
        "aoId": 1,
        "address1": "Test",
        "address2": "SuperMarket",
        "city": "Hyderabad",
        "state": "Telangana",
        "country": "",
        "addressType": "BILLING",
        "addressText": "Test, , Hyderabad, Telangana, 500089",
        "zip": "500089",
        "organizationId": 1,
        "addressId": 2,
        "geoCode": null
      }],
      "addressId": null,
      "createdBy": null,
      "createdDate": "26-09-2021",
      "updatedBy": null,
      "updatedDate": "08-10-2021",
      "expiryDate": "03-10-2021",
      "gstNumber": null
    }
  }

  closeReattemptRequestPopup() {
    this.ReattemptRequestPopup = 'N';
  }

  needActionPopupOpen() {
    this.needActionPopup = 'Y';
  }

  closeNeedActionPopUp() {
    this.needActionPopup = 'N';
  }

  openEscalatePopup() {
    this.escalatePopup = 'Y';
  }

  closeEscalatePopup() {
    this.escalatePopup = 'N';
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }
  /*
      if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
            this.tabClicked = this.g.pageTab;
            let index = this.ordersMainMenu.findIndex((d) => d.tabClicked === this.g.pageTab);
            if (index == -1) {
              for (let ol of this.ordersMainMenu) {
                if (ol.tabClicked === this.g.pageTab) {
                  this.switchPosition(ol);
                }
              }
            }
          } else {
            this.tabClicked = "InTransit";
            this.populateTabData("InTransit","IN_TRANSIT");
          }
    }

    populateTabData(triggered, orderStatus) {
      this.tabClicked = triggered;
      this.orderStatus = orderStatus;
      if (!this.previousStatus) {
        this.getOrdersByStatus(orderStatus);
      }  else {
              this.rerender();
            }
    }
    rerender(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

          dtInstance.destroy();

          this.dtTrigger.next(true);
        });
      }

  selectShip(sl) {
      if (!sl.isSelected) {
        this.masterSelected = false
      }
      this.getCheckedShipList();
    }

     getCheckedShipList() {
        this.checkedList = [];
        for (var i = 0; i < this.orders.length; i++) {
          if (this.orders[i].isSelected) {
            this.checkedList.push(this.orders[i]['orderHeaderId']);
          }
        }
      }
   switchPosition(om) {
      let index = this.ordersMainMenu.indexOf(om);
      om.additional = 'N';
      if (om.displayName !== this.ordersMainMenu[4].displayName) {
        this.ordersMainMenu[4].additional = 'Y';
      }
      var tmp = 5;
      for (let o of this.ordersMainMenu) {
        if (tmp < this.ordersMainMenu.length) {
          if (om.displayName !== this.ordersMainMenu[tmp].displayName) {
            this.ordersMainMenu[tmp].additional = 'Y';
          }
          tmp = tmp + 1;
        }
      }
    }

    needActionPopupOpen() {
      this.needActionPopup = 'Y';
    }

    closeNeedActionPopUp() {
      this.needActionPopup = 'N';
    }

    openEscalatePopup() {
      this.escalatePopup = 'Y';
    }

    closeEscalatePopup() {
      this.escalatePopup = 'N';
    }

    getOrdersByStatus(status) {
      this.dtOptions = {
        "ordering": false,
        pagingType: 'full_numbers',
        lengthMenu: [20, 50, 100, 200],
        pageLength: 20,
        language: {
          searchPlaceholder: 'Search by Order # / Channel Order # / Phone Number / Email'
        },
        serverSide: true,
        ajax: (dataTablesParameters: any, callback) => {
          if (this.previousStatus !== this.orderStatus) {
            dataTablesParameters.start = 0;
            this.previousStatus = this.orderStatus;
          }
          let query: any = {
            orderStatus: this.orderStatus,
            orderType: 'ORDER',
            organizationId: 1,
            page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
            size: dataTablesParameters.length
          }
          if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
            query.searchString = dataTablesParameters.search.value.trim();
          }
          if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === "ROLE_USER") {
            query.accountOwnerId = this.user.accountOwnerId;
          }
          this.g.loaderDisplay = "display";
          var header1 = new HttpHeaders();
          header1 = header1.append('Content-Type', 'application/json');
          header1 = header1.append('Accept', 'application/json');
          header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
          this.http.get(environment.apiUrl + "api/getOrderConsignmentsByStatus", {params: query, headers: header1})
            .subscribe((resp: any) => {
                this.orders = resp.ordersData;
                this.g.loaderDisplay = "";
                this.totalRecords = resp.noOfOrders;
                this.orders.forEach((s) => {
                  s['isSelected'] = false;
                });
                callback({
                  recordsTotal: resp.noOfOrders,
                  recordsFiltered: resp.noOfOrders
                });
              },
              (err) => {
                this.g.loaderDisplay = "";
                this.alertService.error('Error', err);
              });
        }
      };

    }

    ReattemptRequestPopupOpen() {
      this.ReattemptRequestPopup = 'Y';
      this.viewCustomer = {
        "code": "200",
        "message": "Success",
        "role": null,
        "organizationId": 1,
        "id": 1,
        "accountType": "ACCOUNT_OWNER",
        "companyName": "Test123",
        "ownerName": "Sandeep",
        "mobile": 8904291446,
        "email": "sandeep@snithik.com",
        "status": "ACTIVE",
        "panCard": "NO",
        "panCardNumber": null,
        "aadharCard": "NO",
        "aadhartCardNumber": null,
        "mouDocument": "https://shift-images.s3.ap-south-1.amazonaws.com/Img-26-09-2021-8-49-35Before%20change.txt",
        "adddressList": [{
          "aoId": 1,
          "address1": "Test",
          "address2": "SuperMarket",
          "city": "Hyderabad",
          "state": "Telangana",
          "country": "",
          "addressType": "BILLING",
          "addressText": "Test, , Hyderabad, Telangana, 500089",
          "zip": "500089",
          "organizationId": 1,
          "addressId": 2,
          "geoCode": null
        }],
        "addressId": null,
        "createdBy": null,
        "createdDate": "26-09-2021",
        "updatedBy": null,
        "updatedDate": "08-10-2021",
        "expiryDate": "03-10-2021",
        "gstNumber": null
      }
    }

    closeReattemptRequestPopup() {
      this.ReattemptRequestPopup = 'N';
    }


    ngOnInit() {
    }

    onSelect() {
      this.router.navigate(['/admin/codData']);
    }
   */

}
